import React from "react";
import PropTypes from "prop-types";
import Typeahead from "../BaseControls/Typeahead/Typeahead";
import ControlTemplate from "../BaseControls/ControlTemplate";
import {controlPropTypes} from "../formhelpers";

export default class AssociationTypeahead extends React.Component {
    render() {
        const {descriptor, value, options, columns, valueKey, labelKey} = this.props;
        const config = descriptor.config || {options: []};
        return (
            <ControlTemplate {...this.props} className="association-field" extraProps={{style: {display: "block"}}}>
                <Typeahead
                    {...this.props}
                    value={value}
                    options={options || config.options}
                    columns={columns || config.columns}
                    valueKey={valueKey || config.valueKey}
                    labelKey={labelKey || config.labelKey}
                    multiValued={config.multiValued}
                    mode={config.mode}
                    addMissing={config.autoSelectFirstItem !== undefined ? config.autoSelectFirstItem : false }
                    statusMessage={config.statusMessage}
                    showRecordBrowserIcon={config.showRecordBrowserIcon}
                    autoSelectFirstItem={config.autoSelectFirstItem}
                    autoSelectOnlyOption={config.autoSelectOnlyOption}
                    keepSelectionInList={config.keepSelectionInList !== undefined ? config.keepSelectionInList : !config.multiValued}
                />
            </ControlTemplate>
        );
    }
}

AssociationTypeahead.propTypes = {
    ...controlPropTypes({
        options: PropTypes.arrayOf(PropTypes.object),
        columns: PropTypes.arrayOf(PropTypes.shape({
            includeInFilter: PropTypes.bool,
            isSortable: PropTypes.bool,
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })),
        multiValued: PropTypes.bool.isRequired,
        mode: PropTypes.oneOf(["client","server"]),
        otherEntityKey: PropTypes.string,
        valueKey: PropTypes.string,
        labelKey: PropTypes.string,
        addMissing: PropTypes.bool,
        showRecordBrowserIcon: PropTypes.bool,
        autoSelectFirstItem: PropTypes.bool,
        autoSelectOnlyOption: PropTypes.bool,
    }),

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array of those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: PropTypes.oneOfType([PropTypes.object,PropTypes.arrayOf(PropTypes.object)]),

    options: PropTypes.arrayOf(PropTypes.object),
    onRecordbrowserClick: PropTypes.func,
    onSearch: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,

    // these are required for server lists
    isLoading: PropTypes.bool,
    isPartial: PropTypes.bool,
    isError: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/AssociationField/typeahead.js